import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {useParams} from "react-router-dom";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/PricesService.ts";
import {usePricesSelection} from "../hooks/usePricesSelection.ts";

export const DeleteRecordButton = () => {
    const {id: productId} = useParams();
    const {selectedRecords, clearSelection} = usePricesSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord(record.id)));
            clearSelection();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['prices', productId]});
        }
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={mutation.mutate}
        />
    );
};